var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.currentQuestionComponent,{tag:"component",attrs:{"question":_vm.question},on:{"on-answer":_vm.onAnswer}})
}
var staticRenderFns = []

export { render, staticRenderFns }